import Vue from 'vue'
import { mask } from 'vue-the-mask'
import * as components from '../components'
import Error404 from '../views/Errors/Error404'
import draggable from 'vuedraggable'
import VImageInput from 'vuetify-image-input'
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview'
// import VuetifyMoney from 'vuetify-money'
import VueQrcode from 'vue-qrcode';
import VueYandexShare from '@alexlit/vue-yandex-share';

const Application = class {
  constructor() {

  }
  static install(Vue) {
    const options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    const components = options.components
    Vue.directive('mask', mask)
    for (const name in components) {
      const component = components[name]
      Vue.component(name, component)
    }
    Vue.component('error404', Error404)
    Vue.component('VuetifyDraggableTreeview',VuetifyDraggableTreeview)
    Vue.component('draggable', draggable)
    Vue.component(VImageInput.name, VImageInput)
    Vue.component('vue-qrcode', VueQrcode)
    Vue.component('vue-yandex-share', VueYandexShare)
    Vue.prototype.$copy = (o) => JSON.parse(JSON.stringify(o))
    Vue.prototype.$to = function (link) {
      this.$router.push({ path: link })
    }
  }
}

const install = Application.install
Application.install = (Vue, options) => {
  install.call(Application, Vue, {
    components,
    ...options
  })
}

Vue.use(Application)
Vue.use(VuetifyDraggableTreeview)
// Vue.use(VuetifyMoney)

export default new Application()